export const PhoneNumberDisplayContext = {} as const;
export type PhoneNumberDisplayContext =
  typeof PhoneNumberDisplayContext[keyof typeof PhoneNumberDisplayContext];

export const PhoneNumberDisplayDefaultKeys = {
  PhoneCountryDefaultValue: 'all',
  ClientAppDefaultValue: 'shared',
  ContextualDefaultValue: 'default',
  BrandDefaultValue: 'brandless',
} as const;
export type PhoneNumberDisplayDefaultKeys =
  typeof PhoneNumberDisplayDefaultKeys[keyof typeof PhoneNumberDisplayDefaultKeys];
